import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SignOutProps {
  onSignOut: () => void;
}

export function SignOut({ onSignOut }: SignOutProps) {
  return (
    <Button
      variant='ghost'
      size='icon'
      onClick={onSignOut}
      className='right-16'
      title='Sign Out'
    >
      <LogOut className='h-[1.2rem] w-[1.2rem]' />
      <span className='sr-only'>Sign out</span>
    </Button>
  );
}
